import { Stack, Typography } from '@prenuvo/halo';

import { api } from '@/api';
import { isNotEmpty } from '@/shared/util';

import { validatePdfBase64String } from '../util';
import { Loading } from './loading.component';
import { PdfViewer } from './pdf-viewer';

interface CwfActiveDocumentProps {
  careActivityId?: null | string;
  carePlanId?: null | string;
  className?: string;
  studyId?: null | string;
  typeId: string;
}

export function CwfActiveDocument({
  careActivityId,
  carePlanId,
  className,
  studyId,
  typeId,
}: CwfActiveDocumentProps) {
  const isCarePlanDocument = Boolean(careActivityId && carePlanId);

  const {
    data: carePlanData,
    isError: isCarePlanError,
    isFetching: isFetchingCarePlan,
  } = api.fct.documents.query.useGetActiveDocumentByCarePlan(
    {
      payload: {
        care_activity_id: careActivityId!,
        care_plan_id: carePlanId!,
        type_id: typeId,
      },
    },
    { enabled: isCarePlanDocument },
  );

  const {
    data: studyData,
    isError: isStudyError,
    isFetching: isFetchingStudy,
  } = api.fct.documents.query.useGetActiveDocumentByType(
    {
      payload: { study_id: studyId!, type_id: typeId },
    },
    { enabled: !isCarePlanDocument && Boolean(studyId) },
  );

  const data = isCarePlanDocument ? carePlanData : studyData;
  const isError = isCarePlanDocument ? isCarePlanError : isStudyError;
  const isFetching = isCarePlanDocument ? isFetchingCarePlan : isFetchingStudy;

  if (isFetching) {
    return <Loading className={className} />;
  }

  if (isError) {
    return (
      <Stack alignment="center" className={className} justification="center">
        <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT.ERROR" />
      </Stack>
    );
  }

  const url = validatePdfBase64String(data?.base64File);

  if (isNotEmpty(url)) {
    return <PdfViewer className={className} url={url} />;
  }

  return null;
}
